import { render, staticRenderFns } from "./FunButtons.vue?vue&type=template&id=13fa2d82&scoped=true"
import script from "./FunButtons.vue?vue&type=script&lang=js"
export * from "./FunButtons.vue?vue&type=script&lang=js"
import style0 from "./FunButtons.vue?vue&type=style&index=0&id=13fa2d82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa2d82",
  null
  
)

export default component.exports